import { render, staticRenderFns } from "./SpecialNavbar.vue?vue&type=template&id=200ff2d4&scoped=true&"
import script from "./SpecialNavbar.vue?vue&type=script&lang=ts&"
export * from "./SpecialNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialNavbar.vue?vue&type=style&index=0&id=200ff2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ff2d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pillar-science/pillar-science/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200ff2d4')) {
      api.createRecord('200ff2d4', component.options)
    } else {
      api.reload('200ff2d4', component.options)
    }
    module.hot.accept("./SpecialNavbar.vue?vue&type=template&id=200ff2d4&scoped=true&", function () {
      api.rerender('200ff2d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/navbars/SpecialNavbar.vue"
export default component.exports